import React from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'

const Footer = ({
    type = 'full',
    contact = true
}) => {

    return (
        <>
            {
                contact ? 
                    <>
                         <section className={type === 'full' ? "section-contact" : "section-contact side"}>
                            <div className="view-container">
                                <h1>Contact Us</h1>
                                <p>Ready to turn your dreams into reality? Contact us today to begin your unforgettable journey.</p>
                                <div className="city-selector">
                                    <Link to={'/contact'}>Request</Link>
                                </div>
                            </div>
                        </section>
                    </> : ''
            }
            <footer>
                <div className={type === 'full' ? "view-container" : "view-container side"}>
                    <div className="footer-col">
                        <h3>Sadida</h3>
                        <p>Adult Entertainent Network</p>
                    </div><div className="footer-col">
                        <div className="fc-title">
                            Talent
                        </div>
                        <div className="fc-links">
                            <ul>
                                <li>
                                    <Link to={'/talent/rome'}>Rome</Link>
                                </li>
                                <li>
                                    <Link to={'/talent/milan'}>Milan</Link>
                                </li>
                                <li>
                                    <Link to={'/talent'}>All Cities</Link>
                                </li>
                            </ul>
                        </div>
                    </div><div className="footer-col">
                        <div className="fc-title">
                            Information
                        </div>
                        <div className="fc-links">
                            <ul>
                                <li>
                                    <Link to={'/'}>Home</Link>
                                </li>
                                <li>
                                    <Link to={'/talent'}>Talent</Link>
                                </li>
                                <li>
                                    <Link to={'/casting'}>Casting</Link>
                                </li>
                                <li>
                                    <Link to={'/contact'}>Contact</Link>
                                </li>
                            </ul>
                        </div>
                    </div><div className="footer-col">
                        <div className="fc-title">
                            Account
                        </div>
                        <div className="fc-links">
                            <ul>
                                <li>
                                    <Link to={'/account'}>Login</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className={type === 'full' ? "view-container" : "view-container side"}>
                    <div className="disclaimer">
                        <div className="disclaimer-left">
                            &copy; 2024 SADIDA Network
                        </div><div className="disclaimer-right">
                            🔒 All advertisers have been verified to being at least 18 years of age.
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )

}

export default Footer;